import { all, call, put, takeLatest } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { actions as offsetActions } from '@wix/da-shared-react/pkg/Stream/withOffset';
import { FetchType } from '@wix/da-shared-react/pkg/Stream/base/types';
import { fetchTransactions } from '../../actions/studio/earnings';

function* handleFetchTransactions({
  payload: { streamId, limit, offset },
}: ReturnType<typeof fetchTransactions>) {
  const response = yield call(
    requestPuppy,
    {
      method: 'get',
      url: '/earnings/init',
      params: {
        init: false,
        limit,
        offset,
      },
    },
    undefined,
    'studio'
  );

  if (!response || isApiError(response) || !response.transactions) {
    yield put(
      offsetActions.fetchFailure({
        streamId,
        fetchType: FetchType.Next,
        errorMsg: 'Failed to fetch transactions',
      })
    );
    return;
  }

  const { transactions, nextOffset, hasMore } = response;

  yield put(
    offsetActions.fetchSuccess({
      streamId,
      items: transactions,
      hasMore,
      hasLess: true,
      nextOffset,
      reset: true,
    })
  );
}

export default function* saga() {
  yield all([takeLatest(fetchTransactions, handleFetchTransactions)]);
}
